import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanSettingsProgramBoardsRoute: InvariantJiraRoute = {
	name: 'plan-settings-program-boards',
	path: '/jira/plans/:planId/scenarios/:scenarioId/settings/program-boards',
};
